import { useMemo } from "react";
import { InsuranceDocument } from "../../../graphql/__GENERATED__/types";
import Card, { CardFC } from "../../../components/CardList/components/Card";
import { ColorNames } from "../../../theme";
import { formatCpfCnpj } from "../../../utils/formatNumber";
import Typography from "../../../components/Typography";

const FarmerCard: CardFC<InsuranceDocument> = ({ data, active }) => {
  const cardData = useMemo(
    () => ({
      line1: data.farmer?.name || "",
      line2: `${data.crop?.cultureName} - ${data.crop?.area} ha`,
      line3: `${data.property?.address?.city} - ${data.property?.address?.state}`,
      line4: `${
        data.createdAt
          ? new Date(data.createdAt).toLocaleDateString("pt-BR")
          : ""
      }`,
    }),
    [data]
  );

  const cpfCnpj = useMemo(() => {
    return (
      <Typography variant="textMedium" color={ColorNames.GREEN}>
        {formatCpfCnpj(data.farmer?.cpfCnpj!)}
      </Typography>
    );
  }, [data]);

  return (
    <Card
      cardData={cardData}
      detailTop={cpfCnpj}
      color={ColorNames.GREEN}
      active={active}
    />
  );
};

export default FarmerCard;
